module.exports = __webpack_public_path__ + "static/media/Step 8-Fill_In.de113e13.png";